import React from 'react';
import PropTypes from 'prop-types';
import Popup from './Popup';
import PopupHeader from './PopupHeader';
import PopupFooter from './PopupFooter';

class ConfirmPopup extends React.Component {
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { isShow } = this.props;
    if (isShow && !prevProps.isShow) {
      window.addEventListener('keyup', this.onKeyUp);
    }

    if (!isShow && prevProps.isShow) {
      window.removeEventListener('keyup', this.onKeyUp);
    }
  }

  onKeyUp = e => {
    const { confirm } = this.props;
    if (e.keyCode === 27) {
      confirm(false);
    }
  };

  renderHeader = () => {
    const { title, iconName } = this.props;

    return <PopupHeader title={title} iconName={iconName} />;
  };

  renderBody = () => {
    const { messages } = this.props;
    if (messages && messages.length) {
      return messages.map((message, index) => {
        return <div key={index}>{message}</div>;
      });
    }
  };

  renderFooter = () => {
    const { confirm, enabledApply, enabledCancel } = this.props;

    return (
      <PopupFooter
        confirm={confirm}
        enabledApply={enabledApply}
        enabledCancel={enabledCancel}
      />
    );
  };

  render() {
    const { isShow, confirm } = this.props;

    return (
      <Popup
        isShow={isShow}
        confirm={confirm}
        renderHeader={this.renderHeader}
        renderBody={this.renderBody}
        renderFooter={this.renderFooter}
      />
    );
  }
}

ConfirmPopup.propTypes = {
  title: PropTypes.string.isRequired,
  messages: PropTypes.array.isRequired,
  isShow: PropTypes.bool.isRequired,
  confirm: PropTypes.func.isRequired,
  enabledApply: PropTypes.bool,
  enabledCancel: PropTypes.bool,
  iconName: PropTypes.string,
};

ConfirmPopup.defaultProps = {
  title: '',
  messages: [],
  isShow: false,
  confirm: () => {},
  enabledApply: true,
  enabledCancel: true,
  iconName: '',
};

export default ConfirmPopup;
